<template id="popup-container">
  <v-container fluid v-if="!isPartnerLevel">
    <v-row>
      <v-col md="3">
        <v-card class="mx-auto">
          <v-list class="text-left">
            <v-list-item-group>
              <v-list-item v-for="item in menuItems" :key="item.title" :to="item.link">
                <v-list-item-icon>
                  <v-icon v-text="item.icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="item.title"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-col>
      <v-col md="9">
        <v-card class="profile">
          <v-card-text class="px-0">
            <slot />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
  <v-container fluid v-else-if="isPartnerLevel" id="popup-container">
    <v-row>
      <v-col md="3">
        <v-card class="mx-auto">
          <v-list class="text-left">
            <v-list-item-group>
              <v-list-item v-for="item in menuPartnerItems" :key="item.title" :to="item.link">
                <v-list-item-icon>
                  <v-icon v-text="item.icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="item.title"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-col>
      <v-col md="9">
        <v-row>
            <v-col md="12">
              <div class="profile-instruction"><v-img contain :src="$globalConfig.APP_NAME === 'senso' ? '/static/senso-learn-information-icon.png' : '/static/information-icon-green.png'"></v-img>
                <b>Please note:</b> To change your details please contact<a href="mailto:support@improve.online">support@improve.online</a></div>
            </v-col>
         </v-row>
        <v-card class="profile">
          <v-card-text class="px-0">
            <slot />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "ProfileLayout",
  data() {
    return {
      menuItems: [
        { title: "Activity", link: "/profile/activity", icon: "fa-chart-area" },
        { title: "Courses", link: "/profile/courses", icon: "fa-th" },
        { title: "Playlists", link: "/profile/playlists", icon: "fa-list" },
        {
          title: "External Training",
          link: "/profile/external-training",
          icon: "fa-certificate"
        },
        { title: "Profile", link: "/profile/profile", icon: "fa-user" },
        { title: "Password", link: "/profile/password", icon: "fa-lock" }
      ],
      menuPartnerItems: [
        { title: "Profile", link: "/profile/profile", icon: "fa-user" },
        { title: "Password", link: "/profile/password", icon: "fa-lock" }
      ]
    };
  },
  computed: {
    isPartnerLevel: function () {
      const level = this.$store.getters.level;
      if (level == 4) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>
<style>
    .profile {
        min-height: 500px;
        margin-top: 15px;
    }
    
    .profile-instruction{
        display: inline-flex;
        gap: 10px;
    }
    .profile-instruction a{
      text-decoration: underline !important;
      font-weight: 700;
    }
</style>
